import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ConfirmDialog from '../ConfirmDialog';
import Toast from '../Toast';
import useToast from '../../hooks/useToast';

function DashboardHome() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [syncing, setSyncing] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const { toasts, addToast, removeToast } = useToast();

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const response = await axios.get('/api/admin/dashboard', {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        setStats(response.data);
        setError(null);
      } catch (err) {
        setError('Erro ao carregar estatísticas');
        console.error('Error fetching dashboard stats:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  const syncMatches = async () => {
    setSyncing(true);
    try {
      const response = await axios.post('/api/admin/matches/sync', {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      addToast(`Sincronização concluída: ${response.data.message}`, 'success');
    } catch (err) {
      addToast('Erro ao sincronizar partidas', 'error');
      console.error('Error syncing matches:', err);
    } finally {
      setSyncing(false);
      setConfirmOpen(false);
    }
  };

  if (loading) {
    return <div className="p-6">Carregando estatísticas...</div>;
  }

  if (error) {
    return <div className="p-6 text-red-600">{error}</div>;
  }

  return (
    <div className="p-4 lg:p-6">
      <h1 className="text-2xl font-bold mb-6 text-primary">Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
        {/* Users Stats */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-4 text-primary">Usuários</h2>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span>Total:</span>
              <span className="font-bold">{stats.users.total}</span>
            </div>
            <div className="flex justify-between">
              <span>Verificados:</span>
              <span className="font-bold">{stats.users.verified}</span>
            </div>
          </div>
        </div>

        {/* Matches Stats */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-4 text-primary">Partidas</h2>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span>Total:</span>
              <span className="font-bold">{stats.matches.total}</span>
            </div>
            <div className="flex justify-between">
              <span>Concluídas:</span>
              <span className="font-bold">{stats.matches.completed}</span>
            </div>
          </div>
        </div>

        {/* Payments Stats */}
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-lg font-semibold mb-4 text-primary">Pagamentos</h2>
          <div className="space-y-2">
            <div className="flex justify-between">
              <span>Aguardando verificação:</span>
              <span className="font-bold">{stats.payments.pending}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white p-6 rounded-lg shadow">
        <h2 className="text-lg font-semibold mb-4 text-primary">Ações Rápidas</h2>
        <button
          onClick={() => setConfirmOpen(true)}
          disabled={syncing}
          className="bg-tertiary text-white px-4 py-2 rounded hover:bg-tertiary-dark transition focus:ring-2 focus:ring-yellow-400 focus:ring-offset-2 focus:outline-none disabled:opacity-50 min-h-11"
        >
          {syncing ? 'Sincronizando...' : 'Sincronizar Partidas com FIFA'}
        </button>
      </div>

      <ConfirmDialog
        open={confirmOpen}
        title="Sincronizar Partidas"
        message="Tem certeza que deseja sincronizar as partidas com o site da FIFA?"
        confirmLabel="Sincronizar"
        cancelLabel="Cancelar"
        variant="warning"
        loading={syncing}
        loadingLabel="Sincronizando..."
        onConfirm={syncMatches}
        onCancel={() => !syncing && setConfirmOpen(false)}
      />

      <Toast toasts={toasts} removeToast={removeToast} />
    </div>
  );
}

export default DashboardHome;
